(function () {
  const ANIMATION_MS = 2800;
  const EASING = "cubic-bezier(0.45, 0.05, 0.55, 0.95)"; // smooth ease-in-out

  function animateCount(el, target, duration) {
    const start = performance.now();

    function easeInOut(t) {
      return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
    }

    function frame(now) {
      const progress = Math.min((now - start) / duration, 1);
      const value = Math.round(target * easeInOut(progress));
      el.textContent = `${value}%`;

      if (progress < 1) {
        requestAnimationFrame(frame);
      } else {
        el.textContent = `${target}%`;
      }
    }

    requestAnimationFrame(frame);
  }

  function resolveFillPercent(item, percent) {
    const track = item.querySelector(".el-results-stats__track");
    const text = item.querySelector(".el-results-stats__text");
    const countEl = item.querySelector("[data-el-results-count]");
    if (!track || !text) return percent;

    const previousCount = countEl ? countEl.textContent : null;
    if (countEl) countEl.textContent = `${percent}%`;

    const trackWidth = track.clientWidth;
    const previousWidth = text.style.width;
    const previousWrap = text.style.flexWrap;
    const previousWhiteSpace = text.style.whiteSpace;

    // Measure real one-line content width, not the full-width text box
    text.style.width = "max-content";
    text.style.flexWrap = "nowrap";
    text.style.whiteSpace = "nowrap";
    const textWidth = text.getBoundingClientRect().width + 4;

    text.style.width = previousWidth;
    text.style.flexWrap = previousWrap;
    text.style.whiteSpace = previousWhiteSpace;

    if (countEl && previousCount != null) countEl.textContent = previousCount;
    if (!trackWidth) return percent;

    const minPercent = (textWidth / trackWidth) * 100;
    return Math.min(100, Math.max(percent, minPercent));
  }

  function animateFill(fill, percent) {
    const target = `${percent}%`;

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      fill.style.width = target;
      return;
    }

    // Always start from 0 so the bar doesn't jump to ~10%+
    fill.style.transition = "none";
    fill.style.width = "0%";
    void fill.offsetWidth;

    if (typeof fill.animate === "function") {
      const animation = fill.animate([{ width: "0%" }, { width: target }], {
        duration: ANIMATION_MS,
        easing: EASING,
        fill: "forwards",
      });

      animation.onfinish = () => {
        fill.style.width = target;
      };
      return;
    }

    fill.style.transition = `width ${ANIMATION_MS}ms ${EASING}`;
    requestAnimationFrame(() => {
      fill.style.width = target;
    });
  }

  function animateSection(section) {
    if (!section || section.dataset.animated === "true") return;
    section.dataset.animated = "true";

    section.querySelectorAll("[data-el-results-item]").forEach((item) => {
      if (item.classList.contains("is-animated")) return;

      const percent = Math.max(
        0,
        Math.min(100, Number(item.dataset.percent) || 0)
      );
      const countEl = item.querySelector("[data-el-results-count]");
      const fill = item.querySelector("[data-el-results-fill]");
      const fillPercent = resolveFillPercent(item, percent);

      item.classList.add("is-animated");

      if (fill) animateFill(fill, fillPercent);
      if (countEl) animateCount(countEl, percent, ANIMATION_MS);
    });
  }

  function initResultsStats(root) {
    const scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll("[data-el-results-stats]").forEach((section) => {
      // Reset so theme editor reloads can replay
      if (section.dataset.initialized === "true" && section.dataset.animated === "true") {
        return;
      }
      section.dataset.initialized = "true";

      // Keep bars empty until the section is actually viewed
      section.querySelectorAll("[data-el-results-fill]").forEach((fill) => {
        fill.style.width = "0%";
      });
      section.querySelectorAll("[data-el-results-count]").forEach((count) => {
        count.textContent = "0%";
      });

      if (!("IntersectionObserver" in window)) {
        animateSection(section);
        return;
      }

      const observer = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            // Only start when a good chunk of the section is on screen
            if (!entry.isIntersecting || entry.intersectionRatio < 0.35) return;
            animateSection(entry.target);
            obs.unobserve(entry.target);
          });
        },
        {
          threshold: [0.35, 0.5, 0.65],
          rootMargin: "0px",
        }
      );

      observer.observe(section);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initResultsStats());
  } else {
    initResultsStats();
  }

  document.addEventListener("shopify:section:load", (event) => {
    const section =
      event.target.matches?.("[data-el-results-stats]")
        ? event.target
        : event.target.querySelector?.("[data-el-results-stats]");

    if (section) {
      section.dataset.initialized = "false";
      section.dataset.animated = "false";
      section
        .querySelectorAll("[data-el-results-item]")
        .forEach((item) => item.classList.remove("is-animated"));
    }

    initResultsStats(event.target);
  });
})();
